export default __webpack_public_path__ + "static/media/s10.151360c6.jpg";